/* Load a script and return the library
 * @param {String} url
 * @param {String} accessor   Name of the variable that holds the library
 * @returns {Promise}
 * */
export default (url, accessor) =>
  new Promise((resolve, reject) => {
    const timeout = setTimeout(
      () => reject(new Error(`${accessor} timed out`)),
      1e4
    );
    if (typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = () => {
        clearTimeout(timeout);
        const library = window[accessor];
        return library
          ? resolve(library)
          : reject(new Error(`Can't find library using: window.${accessor}`));
      };
      script.onerror = reject;
      document.head.appendChild(script);
    } else {
      reject(new Error('Not loading on the server'));
    }
  });
